<script lang="ts" setup>
import {
  type ComponentListComponent, DisplayAnnotation,
  type TextComponent,
} from '~/utils/generated/graphql'

const props = defineProps<{
  component: ComponentListComponent
}>()

const list = computed(() => {
  if (props.component?.display?.annotation == DisplayAnnotation.CtaItems) {
    return props.component?.list.filter(l => l.display?.annotation == DisplayAnnotation.DiscussionQuestion)
  }
  return props.component?.list
})
</script>

<template>
  <div v-if="component.list && component.list.length > 0">
    <div
      v-if="component?.display?.annotation == DisplayAnnotation.Quote"
      class="text-center text-3xl ps-6 pe-6"
    >
      <div class="inline-block align-baseline">
        <div class="text-blurple-600 text-8xl p-0 m-0 leading-none font-signifier h-10 overflow-hidden">
          &#8220;
        </div>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="text-4xl pt-8 pb-8"
        v-html="(component.list[0] as TextComponent)?.text?.replaceAll('<p>', '').replaceAll('</p>', '')"
      />
      <!-- eslint-enable -->
      <div class="text-blurple-600 text-8xl p-0 m-0 leading-none font-signifier h-10 overflow-hidden">
        &#8221;
      </div>
      <div
        class="mt-6 font-sans text-lg uppercase"
        v-html="(component.list[1] as TextComponent)?.text?.replaceAll('<p>', '').replaceAll('</p>', '')"
      />
    </div>
    <div
      v-else-if="component.display?.annotation == DisplayAnnotation.DiscussionQuestions || component.display?.annotation == DisplayAnnotation.CtaItems"
      class="ps-6 pe-6"
    >
      <!-- eslint-disable vue/no-v-html -->
      <h3
        v-if="component.display?.annotation == DisplayAnnotation.CtaItems"
        class="font-signifier text-center"
        v-html="(component.list[0] as TextComponent)?.text?.replace('<p>', '')?.replace('</p>', '')"
      />
      <!-- eslint-enable -->
      <h3
        v-else
        class="font-signifier text-center"
      >
        {{ $t('discussionQuestions') }}
      </h3>
      <p v-if="component.display?.annotation == DisplayAnnotation.CtaItems && component.list[1]?.display?.annotation == DisplayAnnotation.Cta">
        <span v-html="(component.list[1] as TextComponent).text" />
      </p>
      <ol class="p-0 m-0 ms-4 me-4">
        <!-- eslint-disable vue/no-v-html -->
        <li
          v-for="question in list"
          :key="question.id"
          class="p-0 m-0"
        >
          <span v-html="(question as TextComponent)?.text?.replace('<p>', '')?.replace('</p>', '')" />
        </li>
        <!-- eslint-enable -->
      </ol>
    </div>
    <ContentComponents
      v-else
      :components="component?.list || []"
    />
  </div>
</template>
